// Queries
import PARTNER_ACTIVITIES from '@/assets/graphql/queries/experiencies/AllPartnerActivities.graphql';
import PARTNER_ACTIVITIES_SUMMARY from '@/assets/graphql/queries/experiencies/AllPartnerActivitiesSummary.graphql';
import PARTNER_ACTIVITY from '@/assets/graphql/queries/experiencies/PartnerActivity.graphql';
import ACTIVITY_SUBFILTERS from '@/assets/graphql/queries/experiencies/ActivitySubfilters.graphql';

// Mutations
import MODIFIED_EXPERIECE_ACTIVITY from '@/assets/graphql/mutations/experience/ModifiedExperieceActivity.graphql';
import SET_PARTNERS_SUBFILTER from '@/assets/graphql/mutations/experience/SetPartnersSubfilter.graphql';

// service
import apolloService from '@/services/apolloService';

import type {
  ActivityInformationResponse,
  ActivitySummaryResponse,
  SingleActivityResponse,
  ActivitySubfiltersResponse,
  ModifyExperiencesActivityResponse,
  SetPartnersSubfilterResponse,
  ExperienceStatus,
} from './types';

export default class {
  // QUERIES
  static getAllPartnerActivities(variables?: {
    pageNumber?: number;
    perPage?: number;
    status?: ExperienceStatus;
  }) {
    return apolloService.query<ActivityInformationResponse>(
      PARTNER_ACTIVITIES,
      variables,
      {
        fetchPolicy: 'network-only',
      },
    );
  }

  static getAllPartnerActivitiesSummary() {
    return apolloService.query<ActivitySummaryResponse>(
      PARTNER_ACTIVITIES_SUMMARY,
      undefined,
      {
        fetchPolicy: 'network-only',
      },
    );
  }

  static getPartnerActivity(variables: { activityId: number }) {
    return apolloService.query<SingleActivityResponse>(
      PARTNER_ACTIVITY,
      variables,
      {
        fetchPolicy: 'network-only',
      },
    );
  }

  static getActivitySubfilters(variables: { activity_id: number }) {
    return apolloService.query<ActivitySubfiltersResponse>(
      ACTIVITY_SUBFILTERS,
      variables,
      {
        fetchPolicy: 'network-only',
      },
    );
  }

  // MUTATIONS
  static modifiyExperienceActivity(variables: {
    activity: number;
    change_request: string;
  }) {
    return apolloService.mutate<ModifyExperiencesActivityResponse>(
      MODIFIED_EXPERIECE_ACTIVITY,
      variables,
    );
  }

  static setPartnersSubfilter(variables: {
    subfilters: string[];
    activity_id: number;
  }) {
    return apolloService.mutate<SetPartnersSubfilterResponse>(
      SET_PARTNERS_SUBFILTER,
      variables,
    );
  }
}
